import { recordOverlapsNavigatorRange } from "./timeNavigatorRange";

export function eventMatchesProgramFilter(ev, programId) {
  const pid = programId != null ? String(programId).trim() : "";
  if (!pid) return true;
  if (pid === "__none__") return !(ev?.program_id || "").toString().trim();
  return String(ev?.program_id || "") === pid;
}

export function eventMatchesOrganizerFilter(ev, organizerId) {
  const oid = organizerId != null ? String(organizerId).trim() : "";
  if (!oid) return true;
  return String(ev?.event_organizer_id || "") === oid;
}

export function eventMatchesTimeNavigatorFilter(ev, timeNav) {
  if (!timeNav || timeNav.view === "all") return true;
  return recordOverlapsNavigatorRange(ev, timeNav.bounds, timeNav.view);
}

/** Same Program / Hosted By / time rules as Event Management Events list. */
export function filterEventsByManagementFilters(
  events,
  { programId, organizerId, timeNav } = {}
) {
  return (events || []).filter(
    (ev) =>
      eventMatchesProgramFilter(ev, programId) &&
      eventMatchesOrganizerFilter(ev, organizerId) &&
      eventMatchesTimeNavigatorFilter(ev, timeNav)
  );
}
